import type { ReadAgreementDetail } from "@/schemas/agreement";
import type { CommentRead } from "@/schemas/comments";

export function mapAgreementCommentsToCommentRead(
  comments: ReadAgreementDetail["comments"],
): CommentRead[] {
  return comments.map((c) => ({
    id: c.id,
    comment: c.comment,
    created_at: c.created_at,
    author_name: c.created_by_name,
    author_role_name: c.created_by_role_name,
  }));
}
